#import "~/graphql/fragments/pageContent/postCardsContent.graphql"

fragment flexiblePostCardsManualSelect on flexibleSections_postCardsManualSelect_BlockType {
    __typename
    posts: selectPosts {
       ...postCardsContent
    }
}
